import ajax from '@/plugin/ajax'
import utils from '@/common/utils'
/**
 * 左侧文件夹相关接口
 */

export const sortFolders = function () {
    return ajax({
        method: 'get', url: '/vipapi/folders'
    }).then(function (response) {
        return response
    }).catch(function (error) {
        console.log(error)
    })
}

export const createOtherFolder = function (name) {
    return ajax({
        method: 'put',
        url: '/vipapi/otherFolder',
        data: utils.mailParam({name: name}),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export const deleteOtherFolder = function (id) {
    return ajax({
        method: 'delete',
        url: '/vipapi/otherFolder',
        data: utils.mailParam({id: id}),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export const renameOtherFolder = function (id, name) {
    return ajax({
        method: 'POST',
        url: '/vipapi/otherFolder',
        data: utils.mailParam({id: id, name: name}),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export const sysMailCheck = function (data) {
    return ajax({
        method: 'get',
        url: '/vipapi/mail/check',
        params: data
    })
}

export const autoClean = function (id, day) {
    return ajax({
        method: 'POST',
        url: '/vipapi/config/folder/autoClean',
        data: utils.mailParam({autoCleanDay: day, id: id}),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export const clearAll = function (id) {
    return ajax({
        method: 'POST',
        url: '/vipapi/folder/clearAll',
        data: utils.mailParam({id: id}),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}



// WEBPACK FOOTER //
// ./src/service/folderService.js